import { useMemo } from 'react';
import { PanelLeft } from 'lucide-react';
import Tooltip from '../Tooltip.jsx';
import { useSidebarContext } from './Sidebar.jsx';
import { resolveSidebarVariant, sidebarToggleTooltipProps } from './sidebarVariants.js';

/**
 * Expand / collapse control (Figma: Sidebar Expand/Compress).
 */
const SidebarToggle = ({ expanded = false, onClick, className = '', labels = {} }) => {
  const { variant } = useSidebarContext();
  const palette = useMemo(() => resolveSidebarVariant(variant), [variant]);

  const button = (
    <button
      type="button"
      onClick={onClick}
      className={[
        'flex size-8 shrink-0 items-center justify-center rounded-lg border border-transparent p-1.5',
        palette.toggleText,
        'transition-colors duration-150',
        palette.toggleHover,
        palette.toggleHoverBorder,
        palette.toggleHoverShadow,
        'focus-visible:outline-none focus-visible:ring-2',
        palette.toggleFocusRing,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-label={expanded ? (labels.collapse || 'Collapse sidebar') : (labels.expand || 'Expand sidebar')}
      aria-expanded={expanded}
      aria-controls="sidebar-main-nav"
    >
      <PanelLeft size={20} strokeWidth={2} aria-hidden />
    </button>
  );

  return (
    <Tooltip
      {...sidebarToggleTooltipProps}
      content={expanded ? (labels.collapseShort || 'Collapse') : (labels.expandShort || 'Expand')}
      triggerClassName="inline-flex shrink-0"
    >
      {button}
    </Tooltip>
  );
};

export default SidebarToggle;
